const state = {
  refreshToken: '',
  token: '',
  login: false
}

export default state
